(function() {
    'use strict';

    window.initSliderNemovitosti = function(container = document) {
        const swiperSelectors = container.querySelectorAll('[data-nemovitosti-foto]');
        if (swiperSelectors.length) {
            swiperSelectors.forEach(el => {
                if (el.classList.contains('swiper-initialized') || el.swiper) {
                    return;
                }

                new Swiper(el, {
                    navigation: {
                        nextEl: el.querySelector('.SwiperFrame-next'),
                        prevEl: el.querySelector('.SwiperFrame-prev'),
                    },
                    slidesPerView: 1,
                    observer: true,
                    observeParents: true,
                    lazy: {
                        loadPrevNext: true
                    },
                    on: {
                        init: function () {
                            setTimeout(() => {
                                this.update();
                            }, 0);
                        }
                    }
                });
            });
        }
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => window.initSliderNemovitosti());
    } else {
        window.initSliderNemovitosti();
    }

    // Automatická inicializace nových prvků (např. po AJAXu)
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                if (node.nodeType === 1) { // Node.ELEMENT_NODE
                    if (node.hasAttribute('data-nemovitosti-foto')) {
                        window.initSliderNemovitosti(node.parentElement || document);
                    } else if (node.querySelectorAll('[data-nemovitosti-foto]').length > 0) {
                        window.initSliderNemovitosti(node);
                    }
                }
            });
        });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

})();